import { render, staticRenderFns } from "./Benchmarking.vue?vue&type=template&id=cbd9ec28&scoped=true"
import script from "./Benchmarking.vue?vue&type=script&lang=js"
export * from "./Benchmarking.vue?vue&type=script&lang=js"
import style0 from "./Benchmarking.vue?vue&type=style&index=0&id=cbd9ec28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd9ec28",
  null
  
)

export default component.exports